import { Box } from '@material-ui/core';
import FlagOutlinedIcon from '@material-ui/icons/OutlinedFlag';
import {
  AdminCampaignsIcon,
  AdminHomeScreenIcon,
  AdminResourcesIcon,
  AdminUsersIcon,
  AIIcon,
  LeaderboardIcon,
  ManageIcon
} from '@setvi/shared/components/sicons';
import { Flags, TextColor } from '@setvi/shared/enums';

import { ROUTES } from 'enumsV2';
import { PdvDocIcon } from 'componentsV2/pdv';
import { MenuItemProps } from '../..';

export const AdminLabel = ({
  collapsedDrawer
}: {
  collapsedDrawer: boolean;
}) => (
  <Box
    bgcolor="#F1F1F5"
    fontWeight={700}
    color="#92929D"
    py={2}
    px={3}
    sx={{
      textAlign: collapsedDrawer ? 'center' : 'left'
    }}>
    ADMIN
  </Box>
);

export const adminMenuItems: MenuItemProps[] = [
  {
    title: 'Manage',
    icon: <ManageIcon />,
    baseRoute: ROUTES.ADMIN,
    list: [
      {
        title: 'Resources',
        divider: true,
        dividerAlign: 'text',
        icon: <AdminResourcesIcon fontSize="small" />,
        flag: Flags.ADMIN_RESOURCES,
        route: ROUTES.ADMIN_RESOURCES,
        baseRoute: ROUTES.ADMIN_RESOURCES
      },
      {
        title: 'Users',
        divider: true,
        dividerAlign: 'text',
        icon: <AdminUsersIcon />,
        flag: Flags.ADMIN_USERS,
        route: ROUTES.ADMIN_USERS,
        baseRoute: ROUTES.ADMIN_USERS
      },
      {
        title: 'Campaigns',
        divider: true,
        dividerAlign: 'text',
        icon: <AdminCampaignsIcon />,
        flag: Flags.ADMIN_COMPANY_CAMPAIGN,
        route: ROUTES.ADMIN_CAMPAIGNS,
        baseRoute: ROUTES.ADMIN_CAMPAIGNS
      },
      {
        title: 'AI Sales Enablement',
        divider: true,
        dividerAlign: 'text',
        icon: <AIIcon />,
        flag: Flags.SALES_ENABLEMENT,
        route: ROUTES.ADMIN_AI_SALES_ENABLEMENT,
        baseRoute: ROUTES.HOME_SCREEN
      },
      {
        title: 'Home Screen',
        divider: true,
        dividerAlign: 'text',
        icon: <AdminHomeScreenIcon />,
        flag: Flags.ADMIN_HOME_SCREEN,
        route: ROUTES.HOME_SCREEN,
        baseRoute: ROUTES.HOME_SCREEN
      },
      {
        title: 'Vendor Priority',
        divider: true,
        dividerAlign: 'text',
        // Podium shape -- ranked positions, which is what this screen edits.
        //
        // The sibling admin icons hardcode `fill={htmlColor || '#696974'}` and
        // draw in a 24x25 viewBox; this one inherits currentColor in a 20x21
        // box, so left alone it renders both darker and ~20% larger. Pinning
        // the same grey and dropping to 20px makes one viewBox unit equal one
        // pixel, exactly as it is for the others.
        icon: (
          <LeaderboardIcon
            htmlColor={TextColor.Grey}
            style={{ fontSize: 20 }}
          />
        ),
        flag: Flags.VENDOR_PRIORITY,
        route: ROUTES.ADMIN_VENDOR_PRIORITY,
        baseRoute: ROUTES.ADMIN_VENDOR_PRIORITY
      },
      {
        title: 'Product Data Verification',
        divider: true,
        dividerAlign: 'text',
        // Two sibling entries rather than a nested list: MenuItemList renders its
        // children as flat Items and does not recurse, so a second level would leave
        // this one without a route and navigate(undefined) on click.
        //
        // The PDV prototype's own glyph. Pinned to the admin grey like Vendor
        // Priority; the selected item's `svg path` fill turns it blue.
        icon: <PdvDocIcon size={20} style={{ color: TextColor.Grey }} />,
        flag: Flags.PRODUCT_DATA_VERIFICATION,
        route: ROUTES.ADMIN_PRODUCT_DATA_VERIFICATION,
        baseRoute: ROUTES.ADMIN_PRODUCT_DATA_VERIFICATION
      },
      {
        title: 'Rep Feedback',
        divider: true,
        dividerAlign: 'text',
        icon: (
          <FlagOutlinedIcon
            htmlColor={TextColor.Grey}
            style={{ fontSize: 20 }}
          />
        ),
        flag: Flags.REP_FEEDBACK,
        route: ROUTES.ADMIN_PDV_REP_FEEDBACK,
        baseRoute: ROUTES.ADMIN_PDV_REP_FEEDBACK
      }
    ]
  }
];
